var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"},on:{"click":_vm.handleAppAction}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{staticStyle:{"height":"100%"}})],1),_c('oc-term'),_c('dialog-manager'),_c('side-page-manager'),_c('window-resize-listener')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }